// extracted by mini-css-extract-plugin
export var bodySections = "_am-8";
export var gray = "_am-7";
export var green = "_am-4";
export var iconContainer = "_am-9";
export var iconWidgetContainer = "_am-1";
export var phoneIcon = "_am-2";
export var red = "_am-5";
export var statusDot = "_am-3";
export var widgetContainer = "_am-0";
export var yellow = "_am-6";